import React from "react";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

// Custom.
import Content from "./Content";
import Sidebar from "./Sidebar";

interface LayoutProps {
  children?: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      minHeight: "100vh",
    },
  })
);

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Sidebar />
      {/* <React.Suspense fallback={<VoLoader />}>
        <ErrorBoundary> */}
      <Content>{children}</Content>
      {/* </ErrorBoundary>
      </React.Suspense> */}
    </div>
  );
};

export default Layout;
